import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { environment } from '@environments/environment';
import { SubscriptionService } from '../../services/subscription.service';
import { Subscription } from '../../types/types';
import { toSignal } from '@angular/core/rxjs-interop';
import { AuthService } from '@aihub/core/authorization';

@Component({
  selector: 'app-main-new',
  templateUrl: './main-new.component.html',
  styleUrls: ['./main-new.component.scss'],
})
export class MainNewComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private subscriptionService: SubscriptionService,
    private authService: AuthService,
  ) {}

  user = toSignal(this.authService.getUser());
  environment = environment;

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.subscription_id = params['subscription_id'] || '';
      if (!this.subscription_id) {
        this.subscriptionService.getSubscriptionIds().subscribe(
          (subscriptions: Subscription[]) => {
            this.subscriptions = subscriptions;
            if (
              this.subscriptions.length === 1 &&
              !(environment as any).products['kbin']
            ) {
              this.setSubscription(this.subscriptions[0].subscription_id);
            }
          },
          (err) => console.log(err),
        );
      }
      // else {
      //   this.router.navigate(['/home'], {
      //     queryParamsHandling: 'merge',
      //   });
      // }
    });
  }

  subscriptions: Subscription[] = [];

  setSubscription(subscription_id: string) {
    this.router.navigate(['/home'], {
      queryParams: { subscription_id: subscription_id },
      queryParamsHandling: 'merge',
    });
    this.subscription_id = subscription_id;
  }

  subscription_id: string = '';
}
